import defineComponent from 'flight';
import $ from 'static/script/libs/jquery';
import breakpoints from 'static/script/utils/breakpoints';
import _ from 'static/script/libs/underscore';
import imageSize from 'static/script/utils/image-size';

function ModalImageZoom() {

    let template = $(
        '<div>' +
            '<img>' +
            '<div class="image-zoom-buttons">' +
                '<div class="image-zoom-prev" data-image-zoom-prev>prev</div>' +
                '<div class="image-zoom-next" data-image-zoom-next>next</div>' +
            '</div>' +
        '</div>');

    this.defaultAttrs({
        next: '[data-image-zoom-next]',
        prev: '[data-image-zoom-prev]'
    });

    this._onShow = function (evt, evtData) {
        this.allImages = _.uniq(evtData.all);
        this._show(evtData.current);
    };

    this._show = function (src) {
        this.visible = true;
        let content = template.clone(),
            zoomButtons = content.find('.image-zoom-buttons'),
            verticalPadding = 40,
            zoomButtonWidth = 75,
            horizontalPadding = 20;

        this.src = src;

        content.find('img')
            .attr('src', src)
            .css('max-height', window.innerHeight - verticalPadding + 'px');

        if (this.allImages.length < 2) {
            zoomButtons.remove();
        }
        imageSize(src, function (width, height) {
            let imageScaling = height > (window.innerHeight - verticalPadding) ? (window.innerHeight - verticalPadding) / height : 1;
            let imagePlusMargin = imageScaling * width + horizontalPadding + zoomButtonWidth * 2;
            if (imagePlusMargin < window.innerWidth) {
                zoomButtons
                    .css('width', imagePlusMargin + 'px')
                    .css('margin-left', -zoomButtonWidth + 'px')
                    .css('padding', '0');
            }
            this.trigger(document, 'ui:modal:open', {
                content: content,
                cssClass: 'image-modal'
            });
        }.bind(this));
    };

    this._onClose = function () {
        if (this.visible) {
            this.trigger(document, 'ui:view-item:on-image-zoom-close');
        }
        this.visible = false;
    };

    this._next = function () {
        this._switchImage(+1);
    };

    this._prev = function () {
        this._switchImage(-1);
    };

    this._switchImage = function (delta) {
        if (!this.visible) {
            return;
        }
        let images = this.allImages;
        let currentIndex = _.indexOf(images, this.src);
        let requestedImage = images[(currentIndex + delta + images.length) % images.length];
        this._show(requestedImage);
    };

    this._keyboardNavigation = function (evt) {
        if (document.activeElement !== document.body) {
            return;
        }
        if (!this.visible) {
            return;
        }
        if (evt.keyCode === 37) {
            evt.stopImmediatePropagation();
            this._prev();
        }

        if (evt.keyCode === 39) {
            evt.stopImmediatePropagation();
            this._next();
        }
    };


    this.after('initialize', function () {
        this.on(document, 'ui:view-item:image-zoom-modal', this._onShow);
        this.on(document, 'ui:body-container:on-modal-close', this._onClose);

        this.on('click', {
            next: this._next,
            prev: this._prev
        });

        this.on(document, 'keyup', this._keyboardNavigation);
    });

}

module.exports = defineComponent.component(ModalImageZoom);


// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/app/ui/view-item/image-zoom-modal.js